import PropTypes from 'prop-types';

import Link from 'core/components/Link';

import { resolveScopedStyles } from 'core/utils/styled-jsx';


function FooterSocial(props, context) {
  const {
    theme: {
      animations: {
        hover: hoverAnimation,
      },
      controls: {
        scooter: scooterAtoms,
      },
      socials: socialsAtoms,
    },
  } = props;

  const { socials: socialLinks } = context;

  const scoped = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .social
          display flex
          align-items center
          justify-content space-between
          flex-wrap wrap

          :global(.mobile) &
            margin-top 25px
            flex-basis 100%

        .social-item
          display flex
          align-items center
          justify-content center
      `}</style>
      <style jsx>{`
        .social-item
          width ${scooterAtoms.social.size + 'px'}
          height ${scooterAtoms.social.size + 'px'}
          border-radius ${scooterAtoms.social.borderRadius + 'px'}
          border ${scooterAtoms.social.idle.border}
          background ${scooterAtoms.social.idle.background}
          transition all ${hoverAnimation}
          & + &
            margin ${scooterAtoms.social.margin}
          &:hover
            border ${scooterAtoms.social.hover.border}
            background ${scooterAtoms.social.hover.background}
          & :global([id*="$"])
            fill ${scooterAtoms.social.idle.color}
            transition fill ${hoverAnimation}
          & :global([id*="!"])
            transition stroke ${hoverAnimation}
            stroke ${scooterAtoms.social.idle.color}
          &:hover :global([id*="$"])
            fill ${scooterAtoms.social.hover.color}
          &:hover :global([id*="!"])
            stroke ${scooterAtoms.social.hover.color}
        .social-icon
          width ${scooterAtoms.social.iconSize + 'px'}
          height ${scooterAtoms.social.iconSize + 'px'}
        .link
          font ${props.theme.texts.caption3.font}
      `}</style>
    </scope>
  );

  return (
    <div className={scoped.wrapClassNames('social')}>
      {socialLinks.map(item => {
        const { icon: Icon } = socialsAtoms[item.name] || {};

        if (!Icon) return null;

        return (
          <Link
            key={item.name}
            to={item.link}
            className={scoped.wrapClassNames('social-item')}
            aria-label={item.name}
          >
            {Icon && <Icon className={scoped.wrapClassNames('social-icon')} />}
          </Link>
        );
      })}
      <scoped.styles />
    </div>
  );
}

FooterSocial.propTypes = {
  /** @ignore */
  theme: PropTypes.object,
};

FooterSocial.contextTypes = {
  socials: PropTypes.array,
};

export default FooterSocial;
